import { IconBasket, IconChartBar } from "@tabler/icons-react";
import { MenuOption } from "@/types/pages/dashboard";
import { UserPermission } from "@/types/api/user";

export function getMenuOptions(permissions: UserPermission[]): MenuOption[] {
  const menuOptions: MenuOption[] = [];
  const hasAllPermissions = permissions.includes("all_permissions");
  const hasOrderPermission =
    hasAllPermissions || permissions.includes("all_order");
  const hasDashboardPermission =
    hasAllPermissions || permissions.includes("dashboard_read");

  if (hasOrderPermission) {
    menuOptions.push({
      icon: <IconBasket color="#fff" />,
      label: "Pedidos",
      subOptionsTitle: "Pedidos",
      subOptions: [
        {
          label: "Todos os Pedidos",
          link: "/dash/shipments",
        },
        {
          label: "Pedidos Pendentes",
          link: "/dash/shipments?status=pending",
        },
        {
          label: "Pedidos Enviados",
          link: "/dash/shipments?status=shipped",
        },
      ],
    });
  }

  if (hasDashboardPermission) {
    menuOptions.push({
      icon: <IconChartBar color="#fff" />,
      label: "Admin",
      subOptionsTitle: "Admin",
      subOptions: [
        {
          label: "Dashboard",
          link: "/dash/admin",
        },
        ...(hasAllPermissions
          ? [
              {
                label: "Usuários",
                link: "/dash/admin/users",
              },
            ]
          : []),
      ],
    });
  }

  return menuOptions;
}
